;
define("transaction_line_views_selected_option_giftwrap.tpl", function(){});

